import React from 'react';
import { Typography } from '@mui/material';
import { workspaceStatusLegendLine } from '../../domain/safetyCases/workspaceStatusDimensions';

/** Tinier once-per-workspace status dimension legend (demoted under lifecycle rail). */
export function WorkspaceStatusLegend() {
  return (
    <Typography
      variant="caption"
      color="text.disabled"
      data-testid="workspace-status-legend"
      sx={{ display: 'block', mb: 0.35, fontSize: '0.65rem', lineHeight: 1.2 }}
    >
      {workspaceStatusLegendLine()}
    </Typography>
  );
}
